import React, { Suspense, lazy, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import { MP_CLICKED_CUSTOM_ORDER_REQUEST } from '../../../utils/mixPanelEvents/index';
import { BQ_CLICKED_CUSTOM_ORDER } from '../../../utils/bigQueryEvents/index';
import sendGraphiteEvent from '../../../utils/sendGraphiteEvent';
import { CUSTOM_ORDER_SUBMIT } from '../../../utils/sendGraphiteEvent/events';
import { getFormData } from '../api';
import { FIT_MODAL_CLASS } from '../../../utils/constants';

const CustomOrderModal = lazy(() =>
    import(/* webpackChunkName: 'CustomOrderModal' */'@fiverr-private/custom_order/src/entries/CustomOrderModalEntry')
);

import './style.scss';

const CustomOrder = (props, { pathfinderWrapper, requestContext, biEvents, currencyConverter }) => {
    const [formData, setFormData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(() => _.noop);

    const uploadOptions = {
        objectName: 'message',
        getPolicyUrl: pathfinderWrapper.pathfinder('messages_attachments_policy'),
        createPendingAttachmentIdUrl: pathfinderWrapper.pathfinder('messages_create_pending_attachment')
    };

    const onClickReport = () => {
        biEvents.sendMixPanelEvent({ eventName: MP_CLICKED_CUSTOM_ORDER_REQUEST });
        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_CUSTOM_ORDER });
    };

    const onClick = (e) => {
        e.preventDefault();

        onClickReport();

        if (isValidFormData()) {
            openModal();
            return;
        }

        setIsLoading(true);

        getFormData({ requestContext, pathfinderWrapper })
            .then(({ data }) => {
                setIsLoading(false);
                setFormData(data);
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    const setOpenModalHandle = (open) => {
        setOpenModal(() => open);
    };

    const isValidFormData = () => {
        const { seller, categoriesData } = formData;

        return !!(seller && categoriesData);
    };

    const { currency } = currencyConverter;
    const { params } = requestContext;
    const { slug } = params;
    const { seller, categoriesData } = formData;
    const buttonClassName = classNames('btn-standard', { 'in-progress': isLoading });
    const submitPath = pathfinderWrapper.pathfinder('create_custom_order_request');

    return (
        <div className="custom-order">
            <h5><I18n k={'gig_page_perseus.custom_order.title'}/></h5>
            <button className={buttonClassName} onClick={onClick}>
                <I18n k={'gig_page_perseus.custom_order.get_a_quote'}/>
            </button>
            {isValidFormData() &&
            <Suspense fallback={<div/>}>
                <CustomOrderModal name={FIT_MODAL_CLASS}
                    gigSlug={slug}
                    source="from_gig_page"
                    autoOpen={true}
                    trigger={setOpenModalHandle}
                    currency={currency}
                    seller={seller}
                    categoriesData={categoriesData}
                    submitPath={submitPath}
                    uploadOptions={uploadOptions}
                    onSubmitSuccess={() => {
                        sendGraphiteEvent(CUSTOM_ORDER_SUBMIT);
                    }}/>
            </Suspense>
            }
        </div>
    );
};

CustomOrder.contextTypes = {
    biEvents: PropTypes.object,
    requestContext: PropTypes.object,
    pathfinderWrapper: PropTypes.object,
    currencyConverter: PropTypes.object
};

export default CustomOrder;
